import { render } from "./InspectionSettlement.vue?vue&type=template&id=6b368b34"
import script from "./InspectionSettlement.vue?vue&type=script&lang=js"
export * from "./InspectionSettlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionSettlement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b368b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b368b34', __exports__)) {
    api.reload('6b368b34', __exports__)
  }
  
  module.hot.accept("./InspectionSettlement.vue?vue&type=template&id=6b368b34", () => {
    api.rerender('6b368b34', render)
  })

}


export default __exports__